import { useLayoutEffect } from 'react';
import { GameId } from '@bg-shared/enums/GameId';

export const useGameIdClassName = (gameId: GameId): void => {
    useLayoutEffect(() => {
        const gameClass = `game-${gameId}`;

        document.body.classList.add(gameClass);

        return () => {
            document.body.classList.remove(gameClass);
        };
    }, [gameId]);
};
